// The "this session is being wiped" latch (NOTES-15 review core-I1).
//
// `hardLogout` sets it FIRST, before it sweeps storage, and nothing clears it:
// hardLogout always ends in a hard navigation, so the page that saw the latch
// never gets another session. Anything that persists or prompts on
// pagehide/beforeunload — the note draft store, the note unload guard — reads it
// before writing, because `location.replace` fires those events AFTER the sweep.
//
// Why a latch and not the auth status: `forceLogout` flips `status` before it
// calls hardLogout, but DeleteAccountSection calls hardLogout directly with the
// status still `authenticated`. A gate on the status is only as good as its
// least careful caller; the latch lives in the function every caller shares.
//
// Deliberately import-free, so hardLogout can export the signal without
// importing its readers: noteDraftStore imports authStore, which imports
// hardLogout — hardLogout importing noteDraftStore would close that cycle.

let ending = false;

/** Called by hardLogout before it touches storage. One-way for the page's life. */
export function markSessionEnding(): void {
  ending = true;
}

/** True once hardLogout has started: persist nothing, prompt for nothing. */
export function isSessionEnding(): boolean {
  return ending;
}

/** Tests only — a real page never leaves this state except by navigating away. */
export function _resetSessionEndingForTests(): void {
  ending = false;
}
